import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Alert } from 'src/app/domain/alert';
import { Pagination } from 'src/app/domain/pagination';
import { AlertDTO } from 'src/app/domain/dto/alert.dto';
import { AlertType } from 'src/app/domain/alert-type';
import { Buffer } from 'buffer';

@Injectable({
  providedIn: 'root'
})
export class AlertService {

  url: string = `${environment.BASE_URL}/alerts`;
  httpHeaders = new HttpHeaders({ 'Content-Type': 'application/json', 'Cache-Control': 'no-cache' });

  constructor(private http: HttpClient) { }

  getAlerts(alert: Alert, pagination: Pagination) {

    const params = {
      page: `${pagination.page ?? 1}`,
      per_page: `${pagination.per_page ?? 10}`,
      name: `${alert.name ?? ""}`,
      active: `${alert.active ?? ''}`
    };

    return this.http.get(this.url,
      { responseType: "json", params: params });

  }

  getAlert(id: number) {
    return this.http.get<Alert>(`${this.url}/${id}`,
      { responseType: "json" });

  }
  getAlertTypes() {
    return this.http.get<Array<AlertType>>(`${this.url}/alert-types`,
      { responseType: "json" });
  }
  save(alert: Alert) {
    let dto = new AlertDTO(alert);

    return this.http.post(`${this.url}`, JSON.stringify(dto), {
      headers: this.httpHeaders,
      observe: 'response',
    });
  }
  update(alert: Alert) {
    let dto = new AlertDTO(alert);
    console.log(JSON.stringify(dto));
    return this.http.put(`${this.url}/${alert.id}`, JSON.stringify(dto), {
      headers: this.httpHeaders,
      observe: 'response',
    });
  }
  delete(id: number) {
    return this.http.delete(`${this.url}/${id}`, {
      headers: this.httpHeaders,
      observe: 'response',
    });
  }
  active(id: number) {
    return this.http.put(`${this.url}/${id}/active`, {
      headers: this.httpHeaders,
      observe: 'response',
    });
  }
  deactive(id: number) {
    return this.http.put(`${this.url}/${id}/deactivate`, {
      headers: this.httpHeaders,
      observe: 'response',
    });
  }
}
